<template>
    <div v-if="!withoutBranding" class="chat-footer">
        <a
            :href="url"
            target="_blank"
            rel="noopener noreferrer"
        >
            Powered by <strong>{{ hasWinckBranding() ? 'Winck' : 'Heyloha' }}</strong>
        </a>
    </div>
    <desktop-minimize-button v-if="WidgetType.ICON.equals(typeForWidget)" />
</template>

<script setup lang="ts">
    import DesktopMinimizeButton from '@/components/buttons/DesktopMinimizeButton.vue';
    import useConfiguration from '@/composables/useConfiguration';
    import useAppBranding from '@/composables/useAppBranding';
    import { computed } from 'vue';
    import { WidgetType } from '@keyvue/one-api-client';
    import useWidgetAppearance from '@/composables/useWidgetAppearance';

    const { withoutBranding } = useConfiguration();
    const { hasWinckBranding } = useAppBranding();
    const { typeForWidget } = useWidgetAppearance();

    const url = computed(() => {
        if (hasWinckBranding()) {
            return 'https://winck.nl/ik-wil-dit-ook';
        }

        return 'https://heyloha.ai';
    });
</script>

<style scoped lang="scss">
    .chat-footer {
        background-color: var(--color-widget);
        color: var(--color-widget-text);
        padding: .5rem;
        text-align: center;

        a {
            color: var(--color-widget-text);
            text-decoration: none;
        }
    }
</style>
